module.exports = __webpack_public_path__ + "static/Manrope-ExtraLight-a4b068ee8a8bdb4d976648992bb1db90.ttf";